import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
} from "@material-tailwind/react";
import {
    FormProvider,
    useForm,
} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Pagination from "components/pagination";
import RHFSetCheckbox from "components/form/rhf-set-checkbox";

// Lives inside the <Dialog> so every open remounts the form with fresh
// defaults from the current answerThemes prop (recipe P5).
function AnswerThemingForm({
    answerThemes,
    handleAnswerThemingSubmit,
    themesData,
    themesPage,
    onThemesPageChange,
    validationSchemaAnswerThemes,
    handleClose,
}) {
    const methods = useForm({
        mode: "onChange",
        defaultValues: {
            themes: answerThemes?.themes || [],
        },
        resolver: yupResolver(validationSchemaAnswerThemes),
    });
    // Read both flags up front: formState is a subscription proxy, so a
    // conditional read (`isValid && isDirty`) short-circuits before
    // isDirty while isValid is false. RHF then never subscribes to dirty
    // updates and isDirty stays frozen at false.
    const { isValid, isDirty } = methods.formState;

    return (
        <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(handleAnswerThemingSubmit)}>
                <DialogBody className="dialog__body">
                    <div>
                        {themesData?.data?.map((theme) => (
                            <div
                                className="border-b border-blue-gray-300"
                                key={theme.id}
                            >
                                <div className=" align-bottom">
                                    {/* `themes` is the set of selected theme
                                        ids, accumulated across pages of
                                        themesData while the dialog stays
                                        open. */}
                                    <RHFSetCheckbox
                                        name="themes"
                                        value={theme.id}
                                    />
                                    <span className="align-middle">
                                        {theme.name || "N/A"}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                </DialogBody>
                <DialogFooter className="dialog__footer">
                    <div className="mx-auto">
                        <Pagination
                            currentPage={
                                themesData?.pager?.current_page ||
                                themesPage
                            }
                            lastPage={themesData?.pager?.last_page}
                            onPageChange={onThemesPageChange}
                        />
                    </div>
                    <Button
                        type="button"
                        className="btn btn--secondary"
                        variant="filled"
                        size="lg"
                        onClick={handleClose}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="submit"
                        disabled={!(isValid && isDirty)}
                        onClick={handleClose}
                        className="btn btn--primary ml-2"
                        variant="filled"
                        size="lg"
                    >
                        Save
                    </Button>
                </DialogFooter>
            </form>
        </FormProvider>
    );
}

export default function AnswerThemingDialog({
    showAnswerThemingDialog,
    setShowAnswerThemingDialog,
    answerThemes,
    handleAnswerThemingSubmit,
    themesData,
    themesPage,
    onThemesPageChange,
    validationSchemaAnswerThemes,
}) {
    const handleClose = () => {
        setShowAnswerThemingDialog((showAnswerThemingDialog) => !showAnswerThemingDialog);
    };

    return (
        <Dialog
            open={showAnswerThemingDialog}
            handler={handleClose}
            className="dialog"
        >
            <DialogHeader className="dialog__header">
                Theme Answer
            </DialogHeader>
            <AnswerThemingForm
                answerThemes={answerThemes}
                handleAnswerThemingSubmit={handleAnswerThemingSubmit}
                themesData={themesData}
                themesPage={themesPage}
                onThemesPageChange={onThemesPageChange}
                validationSchemaAnswerThemes={validationSchemaAnswerThemes}
                handleClose={handleClose}
            />
        </Dialog>
    );
}
